// eslint-disable-next-line jira/filename-case, jira/restricted/@atlassian/react-sweet-state
import { createStateHook, type HookStateFunction } from '@atlassian/react-sweet-state';
import { ProductSettingsStore } from './useProductSettingsActions.tsx';
import type { State } from './ProductSettingsResponse.types.tsx';

export const useDatesInitialMonth: HookStateFunction<number | undefined, void> = createStateHook(
	ProductSettingsStore,
	{
		selector: (state: State) =>
			state.productSettings.status === 'loaded'
				? state.productSettings.value.dates.initialMonth
				: undefined,
	},
);

export const useViewBlueprintsEnabled: HookStateFunction<boolean | undefined, void> =
	createStateHook(ProductSettingsStore, {
		selector: (state: State) =>
			state.productSettings.status === 'loaded'
				? state.productSettings.value.viewBlueprints?.enabled
				: undefined,
	});

export const useProductSettingsLoadingState: HookStateFunction<
	'idle' | 'loading' | 'loaded' | 'failed',
	void
> = createStateHook(ProductSettingsStore, {
	selector: (state: State) => state.productSettings.status,
});
